var widgetPriceCompactInitialize = function() {
  var cardsArray = [];
  $(".widget-price-compact-placeholder").each(function() {
    cardsArray.push($(this).data("card"));
  });
  if (cardsArray.length > 0) {
    var i,j,tempArray,chunk = 25;
    for (i=0,j=cardsArray.length; i<j; i+=chunk) {
      tempArray = cardsArray.slice(i,i+chunk);
      $.ajax({
          url: "/widgets/price_compact/js",
          cache: false,
          dataType: "script",
          type: "GET",
          data: {
            cards: tempArray
          }
      });
    }
  }
};
$(function() {
  widgetPriceCompactInitialize();
});
